import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Box, Grid, Card, Container, Typography } from "@mui/material";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import CorrelationP1 from "../pages/CorrelationP1";
import CorrelationP2 from "../pages/CorrelationP2";
import { useSelector } from "react-redux";





function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function CorrelationTab() {
    const [value, setValue] = React.useState(0);
    const group = useSelector((state) => state.auth.group);
    const user_role = useSelector((state) => state.auth.user_role);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const StyledTab = styled(Tab)({
        "&.Mui-selected": {
            color: "red"
        }
    });


    return (

        <div className="App">
            <Helmet>
                <title>Correlation | MES</title>
            </Helmet>
                <Grid
                    container
                    style={{ paddingTop: 0, backgroundColor: '#e0f2f1' }}
                >
                    <Grid item lg={12} md={12} sm={12} xl={12} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Box sx={{ width: '100%' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                { user_role == 'Superuser'|| user_role == 'admin' || user_role == 'staff' ?
                                    <Tabs  value={value} onChange={handleChange} aria-label="basic tabs example" >
                                    <Tab label="Check list" {...a11yProps(0)} />
                                    <Tab label="Unlock" {...a11yProps(1)} />
                                </Tabs> : (group == 'Unlockgiveaway' && user_role == 'user') ? 
                                <Tabs  value={value} onChange={handleChange} aria-label="basic tabs example" >
                                    <Tab label="Check list" {...a11yProps(0)} />
                                </Tabs> : ''}
                            </Box>
                            <CustomTabPanel value={value} index={0}>
                                <CorrelationP1 />
                            </CustomTabPanel>

                            <CustomTabPanel value={value} index={1}>
                                <CorrelationP2 />
                            </CustomTabPanel>
                        </Box>
                    </Grid>
                </Grid>
        </div>
    );
}





